import styled from '@emotion/styled'
import { typography, colors } from '@resiliatech/birdsong'

export const EmptyStateContainer = styled.div`
  align-items: center;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  justify-content: center;
  margin: 0 auto;
  padding: 40px 20px;
  min-height: 430px;
  width: 100%;
  position: relative;
  z-index: 1;
  backdrop-filter: blur(4px);
`

export const BackgroundPlaceholders = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  gap: 16px;
  z-index: 0;
  opacity: 0.15;
  padding: 16px;
  overflow: visible; /* Allow cards to be visible even if they exceed container */
`

export const BackgroundColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: calc(33.333% - 11px);
  overflow: visible; /* Allow cards to extend beyond the column */
`

export const BackgroundCard = styled.div`
  background-color: rgba(128, 128, 128, 0.37);
  border: 1px solid black;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  min-height: 140px; /* Ensure a reasonable minimum height */
  margin-bottom: 16px; /* Add extra space between cards */
  flex-shrink: 0; /* Prevent shrinking */
`

export const Title = styled.div`
  font-size: 18px;
  margin-bottom: 24px;
  text-align: center;
  font-family: 'Helvetica Neue' !important;
`

export const Text = styled.div`
  ${typography.baseline.regularSans}
  max-width: 600px;
  text-align: center;
  margin: 0;
  font-family: 'Helvetica Neue' !important;
  font-size: 16px;
  margin-bottom: 24px;
`
